import axios from "axios";
import { uploadTOS3BucketUrl } from "../../services/QualificationService";
export const handleUploadToS3BucketUrl = async (files, fileListData, onProgress) => {
  if (!files || files.length === 0) return;

  try {
    const formData = new FormData();
    formData.append("uploadFiles", JSON.stringify(files));

    const response = await uploadTOS3BucketUrl(formData);
    const uploadURLList = response.data?.data || [];

    if (!uploadURLList.length || uploadURLList.length !== files.length) {
      throw new Error("Mismatch in number of files and upload URLs");
    }

    const uploadedFileKeys = [];

    if (Array.isArray(fileListData) && fileListData.length > 0) {
        const uploadPromises = fileListData.map((fileData, i) => {
        const uploadURL = uploadURLList[i]?.uploadURL;
        const fileKey = uploadURLList[i]?.fileKey;
        const file = fileData.file ;

        if (!file || !uploadURL) return Promise.resolve(null); 

        return axios.put(uploadURL, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: (progressEvent) => {
            if (onProgress) onProgress(progressEvent, i);
          },
        }).then(uploadResponse => {
          if (uploadResponse.status === 200) {
            return {
              path: fileKey,
              size: file.size,
            };
          } else {
            throw new Error(`Upload failed for ${file.name} with status ${uploadResponse.status}`);
          }
        });
      });

      const results = await Promise.all(uploadPromises);
      // filter out nulls (in case of skipped files)
      return results.filter(Boolean);
    } else {
      // Single file fallback
      const uploadURL = uploadURLList[0]?.uploadURL;
      const fileKey = uploadURLList[0]?.fileKey;

      const uploadResponse = await axios.put(uploadURL, fileListData, {
        headers: {
          "Content-Type": fileListData?.type,
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress) onProgress(progressEvent, 0);
        },
      });

      if (uploadResponse.status === 200) {
        return [{
          path: fileKey,
          size: fileListData?.size,
        }];
      } else {
        throw new Error(`S3 upload failed with status: ${uploadResponse.status}`);
      }
    }

  } catch (error) {
    console.error("Error in file upload:", error);
    throw error;
  }
};


export const handleUploadToS3BucketUrl2 = async (files, fileListData, onProgress) => {
  if (!files || files.length === 0) return;

  try {
    const formData = new FormData();
    formData.append("uploadFiles", JSON.stringify(files));

    const response = await uploadTOS3BucketUrl(formData);
    const uploadURLList = response.data?.data || [];

    if (!uploadURLList.length || uploadURLList.length !== files.length) {
      throw new Error("Mismatch in number of files and upload URLs");
    }

    const uploadPromises = fileListData.map((fileData, i) => {
      const uploadURL = uploadURLList[i]?.uploadURL;
      const fileKey = uploadURLList[i]?.fileKey;
      const file = fileData.file;
      const customId = fileData.meta.customId;

      if (!file || !uploadURL || !customId) {
        console.warn(`Skipping upload for file at index ${i}: Missing file, URL, or customId`);
        return Promise.resolve(null);
      }

      return axios
        .put(uploadURL, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: (progressEvent) => {
            if (onProgress) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              onProgress(customId, percent); 
            }
          },
        })
        .then(uploadResponse => {
          if (uploadResponse.status === 200) {
            return {
              path: fileKey,
              size: file.size,
              customId,
            };
          } else {
            throw new Error(`Upload failed for ${file.name} with status ${uploadResponse.status}`);
          }
        })
        .catch(error => {
          console.error(`Upload failed for ${file.name}:`, error);
          return null;
        });
    });

    const results = await Promise.all(uploadPromises);
    return results.filter(Boolean);
  } catch (error) {
    console.error("Error in file upload:", error);
    throw error;
  }
};
